import { i18n } from '@lingui/core';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const SERVER_MESSAGES = {
    'Bedroom and dressing': msg`Bedroom and dressing`,
    'Children room': msg`Children room`,
    'Guest room': msg`Guest room`,
    'Living room': msg`Living room`,
    Kitchen: msg`Kitchen`,
    'Office / Workshop': msg`Office / Workshop`,
    'Dining room': msg`Dining room`,
    'Play / Relax room': msg`Play / Relax room`,
    Hall: msg`Hall`,
    'Bath room': msg`Bath room`,
    Other: msg`Other`,
    Apartment: msg`Apartment`,
    'Single family house': msg`Single family house`,
    'Multi family house': msg`Multi family house`,
    Office: msg`Office`,
    Tenant: msg`Tenant`,
    Owner: msg`Owner`,
    Yes: msg`Yes`,
    No: msg`No`,
    'No Windows': msg`No Windows`,
    'Single-glazed': msg`Single-glazed`,
    'Double-glazed': msg`Double-glazed`,
    'Triple-glazed': msg`Triple-glazed`,
    'Internal wall': msg`Internal wall`,
    'External wall': msg`External wall`,
    Brick: msg`Brick`,
    Concrete: msg`Concrete`,
    Painted: msg`Painted`,
    Plaster: msg`Plaster`,
    Stone: msg`Stone`,
    Tile: msg`Tile`,
    Wallpaper: msg`Wallpaper`,
    Wood: msg`Wood`,
    Home: msg`Home`,
    AUTO: msg`AUTO`,
    Driver: msg`Driver`,
    Clock: msg`Clock`,
    Sun: msg`Sun`,
    Comfort: msg`Comfort`,
    Manual: msg`Manual`,
    Suitcase: msg`Suitcase`,
    Heat: msg`Heat`,
    ECO: msg`ECO`,
    Moon: msg`Moon`,
    Snowflake: msg`Snowflake`,
    PROG: msg`PROG`,
    Centralization: msg`Centralization`,
    Classic: msg`Classic`,
    Reverse: msg`Reverse`,
    'Left of the heater': msg`Left of the heater`,
    'Right of the heater': msg`Right of the heater`,
    'Below the heater': msg`Below the heater`,
    Soft: msg`Soft`,
    Hard: msg`Hard`,
    'PDL already used by another site': msg`This PDL is already used by another site. Please double check it. If it is correct, call a supervisor.`,
    'Reattach a D-Box': msg`Reattach a D-Box`,
    'Fix offline D-Box': msg`Fix offline D-Box`,
    'Add or replace a D-Box': msg`Add or replace a D-Box`,
    'Remove a D-Box': msg`Remove a D-Box`,
    'Split or merge a room': msg`Split or merge a room`,
    'Adjust a radiator': msg`Adjust a radiator`,
    'change wiring': msg`Change wiring`,
    'Repair damage': msg`Repair damage`,
    Safety: msg`Safety`,
    'No intervention needed': msg`No intervention needed`,
    // Deepomatic conformity issues messages
    is_blurry_issue: msg`The picture is blurry`,
    is_photo_of_photo_issue: msg`Picture of a picture detected`,
    // Deepomatic context issues messages
    fiche_signaletique_issue: msg`Heater label not found`,
    bouton_ecran_numerique_issue: msg`Screen or buttons not found`,
    tableau_electrique_avant_issue: msg`Electrical panel not found`,
    tableau_electrique_apres_issue: msg`Electrical panel not found`,
    radiateur_issue: msg`Heater and Dbox not found`,
    cablage_issue: msg`Dbox wiring not found`,
    // Deepomatic tasks issue messages
    // Buttons or screen
    ecran_numerique_temperature_issue: msg`Screen temperature could not be read`,
    // Heater label
    fiche_marque_radiateur_issue: msg`Heater's brand could not be read`,
    fiche_ref_radiateur_issue: msg`Heater's model could not be read`,
    // Electrical panel before
    presence_30mA_protection_issue: msg`30mA protection not found`,
    // Heater and dbox
    presence_DBox_issue: msg`Dbox is absent`,
    check_validite_position_DBox_issue: msg`Dbox is not correctly positioned`,
    position_DBox_issue: msg`Dbox position value not processed`,
    absence_cable_non_range_issue: msg`Cables under the heater`,
    // Electrical panel after
    absence_disjoncteur_baisse_issue: msg`At least one circuit breaker down`,
    // Wiring
    cablage_MAC_validite_issue: msg`The detected MAC address doesn't match the provided one`,
    cablage_serre_gaine_valide_issue: msg`Sheath not properly inserted up to sheath clamp`,
    cablage_gaine_valide_issue: msg`Copper part detected`,
    cablage_vis_valide_issue: msg`Less than four screws detected`,
    // Deepomatic tasks success messages
    // electrical panel before
    presence_30mA_protection_success: msg`30mA protection found`,
    // Heater and dbox
    presence_DBox_success: msg`Dbox is present`,
    check_validite_position_DBox_success: msg`Dbox is correctly positioned`,
    absence_cable_non_range_success: msg`There are no cables under the heater`,
    // Electrical panel after
    absence_disjoncteur_baisse_success: msg`No circuit breaker down`,
    // Wiring
    cablage_MAC_validite_success: msg`The detected MAC address matches the provided one`,
    cablage_serre_gaine_valide_success: msg`Sheath properly inserted up to sheath clamp`,
    cablage_gaine_valide_success: msg`No copper part visible`,
    cablage_vis_valide_success: msg`Four screws detected`,
};

interface ITransServerMessageProps {
    id: string;
}

const TransServerMessage: React.FC<ITransServerMessageProps> = ({ id }) => {
    const { _ } = useLingui();
    const key = id as keyof typeof SERVER_MESSAGES;
    const message = SERVER_MESSAGES[key];
    return <>{message ? _(message) : id}</>;
};

const getTransServerMessageString = function (id: string) {
    const key = id as keyof typeof SERVER_MESSAGES;
    const message = SERVER_MESSAGES[key];
    return message ? i18n._(message) : id;
};

export { TransServerMessage, getTransServerMessageString };
